var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("PositionWarning", {
        attrs: { show: _vm.showPositionWarning, message: _vm.positionWarning },
        on: { dismiss: _vm.dismissWarning },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleSection", "textEditorSection")
                },
              },
            },
            [
              _c("strong", [_vm._v("Text Editor")]),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.textEditorSection
                    ? "chevron-up"
                    : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                { attrs: { visible: _vm.isOpen.textEditorSection } },
                [
                  _c(
                    "div",
                    [
                      _c("FormGroupCharLimit", {
                        attrs: {
                          label: "Text",
                          value: _vm.text,
                          max: _vm.maxChars,
                          "max-editable": "",
                          copy: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.onChange("maxChar", $event)
                          },
                          copy: _vm.onCopy,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ state }) {
                              return [
                                _vm.isMultiLineField
                                  ? _c("b-textarea", {
                                      ref: "textEdit",
                                      attrs: {
                                        value: _vm.text,
                                        state: state,
                                        disabled: _vm.isEditingDisabled,
                                        rows: "8",
                                      },
                                      on: {
                                        input: _vm.handleTextInput,
                                        blur: _vm.onBlurText,
                                      },
                                    })
                                  : _c("b-input", {
                                      ref: "textEdit",
                                      attrs: {
                                        value: _vm.text,
                                        state: state,
                                        disabled: _vm.isEditingDisabled,
                                      },
                                      on: { input: _vm.handleTextInput },
                                    }),
                                _vm._v(" "),
                                _vm.target.isTocLine
                                  ? _c(
                                      "b-form-group",
                                      {
                                        staticClass: "mt-2 mb-2",
                                        attrs: { label: "Page Number" },
                                      },
                                      [
                                        _c("b-input", {
                                          attrs: {
                                            value: _vm.target.tocPageNumber,
                                            disabled: _vm.isEditingDisabled,
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.onChange(
                                                "tocPageNumber",
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center justify-content-between w-100 color-checkbox-container",
                                  },
                                  [
                                    _vm.options.colorSelector
                                      ? _c("ColorPicker", {
                                          attrs: {
                                            value: _vm.target.fontColor,
                                            themes: _vm.themes,
                                            "is-text-editor": true,
                                            position: "top-right",
                                            copy: "",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.onChange(
                                                "fontColor",
                                                $event
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "text-case-checkboxes" },
                                      [
                                        _c(
                                          "b-checkbox",
                                          {
                                            on: { change: _vm.toggleTitleCase },
                                            model: {
                                              value: _vm.titleCase,
                                              callback: function ($$v) {
                                                _vm.titleCase = $$v
                                              },
                                              expression: "titleCase",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Title Case\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-checkbox",
                                          {
                                            on: { change: _vm.toggleAllCaps },
                                            model: {
                                              value: _vm.allCaps,
                                              callback: function ($$v) {
                                                _vm.allCaps = $$v
                                              },
                                              expression: "allCaps",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    All Caps\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.isMultiLineField && _vm.hasMultipleLines
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass: "mt-2 w-100",
                                        attrs: {
                                          variant: "outline-secondary",
                                          size: "sm",
                                          disabled: _vm.isSeparating,
                                        },
                                        on: {
                                          click: _vm.separateIntoTextBlocks,
                                        },
                                      },
                                      [
                                        _vm.isSeparating
                                          ? _c("b-spinner", {
                                              staticClass: "mr-1",
                                              attrs: { small: "" },
                                            })
                                          : _c("b-icon", {
                                              staticClass: "mr-1",
                                              attrs: { icon: "layout-split" },
                                            }),
                                        _vm._v(
                                          "\n                Separate into separate text blocks\n              "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("ChatGPTForm", {
                                  staticClass: "flex-grow-1 d-flex mt-2",
                                  attrs: { value: _vm.target.text },
                                  on: { change: _vm.onChange },
                                }),
                                _vm._v(" "),
                                _vm.isMultiLineField &&
                                _vm.options.extendContainer
                                  ? _c("ExtendContainerRow", {
                                      staticClass: "mt-2",
                                      attrs: {
                                        target: _vm.target,
                                        config: _vm.options.extendContainer,
                                      },
                                      on: {
                                        "data-updated":
                                          _vm.updateContainerSettings,
                                        "extend-container":
                                          _vm.onExtendContainer,
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleSection", "textSettingsSection")
                },
              },
            },
            [
              _c("strong", [_vm._v("Text Settings")]),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.textSettingsSection
                    ? "chevron-up"
                    : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                { attrs: { visible: _vm.isOpen.textSettingsSection } },
                [
                  _c(
                    "div",
                    [
                      _vm.themeStyles
                        ? _c(
                            "b-form-group",
                            { attrs: { label: "Text Style" } },
                            [
                              _c("Multiselect", {
                                attrs: {
                                  placeholder: "Select style",
                                  "track-by": "id",
                                  label: "name",
                                  options: _vm.groupedThemeStyles,
                                  "group-label": "name",
                                  "group-values": "children",
                                  "group-select": false,
                                  multi: false,
                                  "allow-empty": false,
                                  "select-label": "",
                                  "deselect-label": "",
                                },
                                on: { input: _vm.applyTextStyle },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "option",
                                      fn: function (props) {
                                        return [
                                          !props.option.$isLabel
                                            ? _c(
                                                "span",
                                                {
                                                  style: _vm.getStylePreview(
                                                    props.option
                                                  ),
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getStyleOptionName(
                                                        props.option
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "themes-group-label",
                                                  style: _vm.getStylePreview(
                                                    props.option
                                                  ),
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.option.$groupLabel
                                                    )
                                                  ),
                                                ]
                                              ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "singleLabel",
                                      fn: function (props) {
                                        return [
                                          props.option.$isLabel
                                            ? _c(
                                                "span",
                                                {
                                                  style: { fontWeight: "bold" },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.option.$groupLabel
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  style: _vm.getStylePreview(
                                                    props.option
                                                  ),
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getStyleOptionName(
                                                        props.option
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2593590255
                                ),
                                model: {
                                  value: _vm.selectedStyle,
                                  callback: function ($$v) {
                                    _vm.selectedStyle = $$v
                                  },
                                  expression: "selectedStyle",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.options.fontSelector
                        ? _c(
                            "b-form-group",
                            { attrs: { label: "Font" } },
                            [
                              _c("Multiselect", {
                                attrs: {
                                  placeholder: "Font",
                                  "track-by": "value",
                                  label: "name",
                                  options: _vm.getFonts,
                                  "allow-empty": false,
                                },
                                on: { select: _vm.handleFontChange },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "option",
                                      fn: function (props) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              class: {
                                                "font-used-in-theme":
                                                  _vm.fontsUsedInStyles.includes(
                                                    props.option.value
                                                  ),
                                                "theme-font-separator":
                                                  props.option.isLastUsed,
                                              },
                                              style: {
                                                fontFamily: props.option.value,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(props.option.name) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "singleLabel",
                                      fn: function (props) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              style: {
                                                fontFamily: props.option.value,
                                              },
                                            },
                                            [_vm._v(_vm._s(props.option.name))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  168950865
                                ),
                                model: {
                                  value: _vm.fontVal,
                                  callback: function ($$v) {
                                    _vm.fontVal = $$v
                                  },
                                  expression: "fontVal",
                                },
                              }),
                              _vm._v(" "),
                              _vm.options.fontSelector &&
                              (!_vm.target.fontFamily || !_vm.fontVal)
                                ? _c("small", { staticClass: "text-warning" }, [
                                    _c("i", {
                                      staticClass:
                                        "fas fa-exclamation-triangle mr-1",
                                    }),
                                    _vm._v(
                                      "\n              Please select a font for this text field\n            "
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center justify-content-between",
                                    },
                                    [
                                      _c("span", [_vm._v("Alignment")]),
                                      _vm._v(" "),
                                      _c("img", {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                        staticStyle: {
                                          height: "16px",
                                          cursor: "pointer",
                                        },
                                        attrs: {
                                          src: "/img/icons/text-fit-width.png",
                                          alt: "Set field to text width",
                                          title: "Set field to text width",
                                        },
                                        on: {
                                          mousedown: function ($event) {
                                            $event.preventDefault()
                                          },
                                          click: _vm.onFitTextWidthClick,
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: {
                              value: _vm.target.textAlign,
                              options: _vm.getAlignOptions,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.onChange("textAlignment", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Size",
                                    disabled: _vm.target.locked,
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      value: _vm.config.fontSize,
                                      type: "number",
                                      min: "0",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.onChange("fontSize", $event)
                                      },
                                      dblclick: _vm.selectValueOnDblclick,
                                      keypress: _vm.preventNegativeInput,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Opacity" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      value: _vm.target.opacity,
                                      type: "number",
                                      min: "0",
                                      step: "0.01",
                                      max: "1",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.onChange("opacity", $event)
                                      },
                                      dblclick: _vm.selectValueOnDblclick,
                                      keypress: _vm.preventNegativeInput,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center" },
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "me-3",
                              attrs: {
                                checked: _vm.target.isCurved,
                                name: "check-button",
                                switch: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.onChange(
                                    "changeCurved",
                                    !_vm.target.isCurved
                                  )
                                },
                              },
                            },
                            [_vm._v("\n              Curved\n            ")]
                          ),
                          _vm._v(" "),
                          _vm.target.isCurved
                            ? _c(
                                "b-form-checkbox",
                                {
                                  staticClass: "ml-1",
                                  attrs: {
                                    checked: _vm.target.flipped,
                                    name: "check-button",
                                    switch: "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onChange(
                                        "changeFlipped",
                                        !_vm.target.flipped
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Flipped\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.target.isCurved
                        ? _c(
                            "b-form-group",
                            { attrs: { label: "" } },
                            [
                              _c(
                                "b-input-group",
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "append",
                                        fn: function () {
                                          return [
                                            _c("b-input", {
                                              attrs: {
                                                min: "0",
                                                max: "1",
                                                step: "0.001",
                                                type: "number",
                                                value: _vm.diameterToRatio(
                                                  _vm.target.curvedDiameter
                                                ),
                                                formatter:
                                                  _vm.betweenZeroAndOneFormatter,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.onRatioInput(
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    3198641634
                                  ),
                                },
                                [
                                  _c("b-input", {
                                    attrs: {
                                      min: "5",
                                      max: "3000",
                                      step: "0.001",
                                      type: "range",
                                      value: _vm.target.curvedDiameter,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.onChangeThrottle(
                                          "changeRadius",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("PositionAndSize", {
        attrs: {
          x: _vm.target.left,
          y: _vm.target.top,
          w: _vm.config.width,
          h: _vm.config.height,
          "is-open": _vm.isOpen,
        },
        on: { toggleSection: _vm.toggleSectionHandler, input: _vm.onChange },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleSection", "actionSection")
                },
              },
            },
            [
              _c("strong", [_vm._v("Actions")]),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.actionSection
                    ? "chevron-up"
                    : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                { attrs: { visible: _vm.isOpen.actionSection } },
                [
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "text-editor-actions d-flex my-2" },
                      [
                        _c(
                          "DropdownCounter",
                          {
                            attrs: {
                              value: _vm.target.charSpacing,
                              title: "Text Spacing",
                              step: 10,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.onChange("textSpacing", $event)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "glyphicon glyphicon-text-width",
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.fontFamilyWeights.length
                          ? _c("div", { staticClass: "dropdown" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "dropdown-toggle d-flex align-items-center h-100",
                                  attrs: {
                                    "aria-expanded": "false",
                                    "aria-haspopup": "true",
                                    "data-toggle": "dropdown",
                                    title: "Tracking",
                                    type: "button",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "glyphicon glyphicon glyphicon-bold",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu menu-wide p-0 w-100",
                                },
                                _vm._l(
                                  _vm.fontFamilyWeights,
                                  function (font, index) {
                                    return _c(
                                      "button",
                                      {
                                        key: index,
                                        staticClass: "dropdown-item p-2",
                                        style: { "font-family": font.index },
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onChangeTextWeight(
                                              font.index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.TEXT_WEIGHT[font.weight]
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "LineHeightDropdown",
                          {
                            attrs: { value: _vm.target.lineHeight },
                            on: {
                              input: function ($event) {
                                return _vm.onChange("textLeading", $event)
                              },
                            },
                          },
                          [_c("i", { staticClass: "cil-line-spacing" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: { title: "Set to template width" },
                            on: {
                              click: function ($event) {
                                return _vm.onChange("setTemplateSizeByWidth")
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: { src: "/img/icons/expand.svg" },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: { title: "Center horizontally" },
                            on: {
                              click: function ($event) {
                                return _vm.onChange("centerToTemplateWidth")
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/img/icons/align-center.png",
                                alt: "align-center-icon",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: { title: "Center vertically" },
                            on: {
                              click: function ($event) {
                                return _vm.onChange("centerToTemplateHeight")
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/img/icons/vertical-alignment.png",
                                alt: "align-center-icon",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: { title: "Left align to template" },
                            on: {
                              click: function ($event) {
                                return _vm.onChange("leftAlignToTemplate")
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/img/icons/align-left.png",
                                alt: "align-left-icon",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: { title: "Right align to template" },
                            on: {
                              click: function ($event) {
                                return _vm.onChange("rightAlignToTemplate")
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/img/icons/align-right.png",
                                alt: "align-right-icon",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("DropdownSlider", {
                          attrs: {
                            label: "Size",
                            tooltip: "Set superscript",
                            value: _vm.config.fontSize,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.onChange("superscript", $event)
                            },
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "placeholder",
                              fn: function () {
                                return [
                                  _c("i", { staticClass: "fa fa-superscript" }),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: { title: "Set default superscript" },
                            on: {
                              click: function ($event) {
                                return _vm.onChange("superscriptDefault")
                              },
                            },
                          },
                          [_c("i", { staticClass: "fa fa-superscript" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: { title: "Set default subscript" },
                            on: {
                              click: function ($event) {
                                return _vm.onChange("subscriptDefault")
                              },
                            },
                          },
                          [_c("i", { staticClass: "fa fa-subscript" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: { title: "Set regular" },
                            on: {
                              click: function ($event) {
                                return _vm.onChange("resetFontSize")
                              },
                            },
                          },
                          [_c("i", { staticClass: "fa fa-heading" })]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "position-fixed apply-to-all-text-dropdwon-section",
                      },
                      [
                        _c("ApplyToAllTextDropdown", {
                          attrs: { options: _vm.options, target: _vm.target },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleSection", "relatedFieldSection")
                },
              },
            },
            [
              _c("strong", [_vm._v("Related Field")]),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.relatedFieldSection
                    ? "chevron-up"
                    : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                { attrs: { visible: _vm.isOpen.relatedFieldSection } },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "b-form-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Related field" } },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      value: _vm.target.relatedField?.field,
                                      options: _vm.relatedTemplateFields,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onChange(
                                          "changeRelatedField",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Margin" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      value: _vm.target.relatedField?.margin,
                                      type: "number",
                                      min: "0",
                                      step: "1",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.onChange(
                                          "changeMargin",
                                          $event
                                        )
                                      },
                                      dblclick: _vm.selectValueOnDblclick,
                                      keypress: _vm.preventNegativeInput,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-form-row", [
                        _vm.isMultiLineField
                          ? _c(
                              "div",
                              { staticClass: "d-flex align-items-baseline" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "btn-group" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "align-to-btn mt-1 btn-sm",
                                        attrs: {
                                          variant: "primary",
                                          "data-action": "align-to-btn",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.redraw()
                                          },
                                        },
                                      },
                                      [
                                        _vm.target.alignToField
                                          ? _c("span", [
                                              _vm._v("Align to "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.target.alignToField
                                                  )
                                                ),
                                              ]),
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                "Select a field for text alignment"
                                              ),
                                            ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-dropdown",
                                      {
                                        ref: "alignToFieldDropdown",
                                        staticClass:
                                          "mt-1 align-options-dropdown",
                                        attrs: {
                                          variant: "primary",
                                          right: "",
                                          "no-caret": "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "button-content",
                                              fn: function () {
                                                return [
                                                  _c("i", {
                                                    staticClass: "fas fa-cog",
                                                  }),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          2137381088
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c(
                                          "b-dropdown-form",
                                          [
                                            _c(
                                              "b-form-radio-group",
                                              {
                                                staticClass: "mb-2",
                                                model: {
                                                  value:
                                                    _vm.shouldMaximizeFontSize,
                                                  callback: function ($$v) {
                                                    _vm.shouldMaximizeFontSize =
                                                      $$v
                                                  },
                                                  expression:
                                                    "shouldMaximizeFontSize",
                                                },
                                              },
                                              [
                                                _c(
                                                  "b-form-radio",
                                                  { attrs: { value: false } },
                                                  [
                                                    _vm._v(
                                                      "\n                        Keep font size\n                      "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-form-radio",
                                                  { attrs: { value: true } },
                                                  [
                                                    _vm._v(
                                                      "\n                        Maximize font size\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                model: {
                                                  value: _vm.keepLineBreaks,
                                                  callback: function ($$v) {
                                                    _vm.keepLineBreaks = $$v
                                                  },
                                                  expression: "keepLineBreaks",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      Keep line breaks\n                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.shouldMaximizeFontSize
                                              ? _c(
                                                  "b-form-checkbox",
                                                  {
                                                    model: {
                                                      value:
                                                        _vm.useTemplateFontSize,
                                                      callback: function ($$v) {
                                                        _vm.useTemplateFontSize =
                                                          $$v
                                                      },
                                                      expression:
                                                        "useTemplateFontSize",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      Use template font size as max\n                    "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("b-form-select", {
                                              staticClass: "mt-3",
                                              attrs: {
                                                value: _vm.target.alignToField,
                                                options: _vm.alignToOptions,
                                                size: "sm",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.onChange(
                                                    "changeAlignToField",
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-checkbox",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: false,
                                        expression: "false",
                                      },
                                    ],
                                    staticClass: "ml-1",
                                    attrs: {
                                      checked: _vm.getAutoPositionValue(
                                        _vm.target
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onChangeAutoPositionValue(
                                          $event
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Auto position\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          attrs: { variant: "danger" },
          on: {
            click: function ($event) {
              return _vm.onChange("delete")
            },
          },
        },
        [
          _c("b-icon", { attrs: { icon: "trash" } }),
          _vm._v("\n    Delete\n  "),
        ],
        1
      ),
      _vm._v(" "),
      _c("LockToggle"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }